(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_marquee"] && !Shopify.designMode) return;
  try {
    

    const track = document.querySelector(".gateway-product-marquee");
    track.innerHTML += track.innerHTML;

    let position = 0;
    let speed = 1.2;
    let targetSpeed = 1;

    function animate() {
        speed += (targetSpeed - speed) * 0.05; 
        position -= speed;
        const halfWidth = track.scrollWidth / 2;
        if (Math.abs(position) >= halfWidth) {
            position = 0;
        }
        track.style.transform = `translateX(${position}px)`;
        requestAnimationFrame(animate);
    }
    animate();
    track.addEventListener("mouseenter", () => {
        targetSpeed = 0.3; 
    });
    track.addEventListener("mouseleave", () => {
        targetSpeed = 1; 
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
